/**
 * 教师端全局配置
 */

const loginBgAssets = {
  "login-bg.jpg": require("@/assets/img/login/login-bg.jpg"),
  "login-bg-admin.jpg": require("@/assets/img/login/login-bg-admin.jpg"),
  "login-bg-teacher.jpg": require("@/assets/img/login/login-bg-teacher.jpg")
};

const loginBgKey = process.env.VUE_APP_LOGIN_BG || "login-bg-teacher.jpg";

const settings = {
  title: process.env.VUE_APP_TITLE,
  titleMain: process.env.VUE_APP_TITLE_MAIN,
  titleSub: process.env.VUE_APP_TITLE_SUB,
  loginBg: loginBgAssets[loginBgKey] || loginBgAssets["login-bg-teacher.jpg"],
  baseApi: process.env.BASE_API,
  env: process.env.VUE_APP_ENV,
  isDev: process.env.VUE_APP_ENV === "dev",
  isProd: process.env.VUE_APP_ENV === "prod",
  /** 本仓库仅教师端 */
  isTeacher: true,
  isAdmin: false
};

export default settings;



// WEBPACK FOOTER //
// ./src/settings.js